/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nights: NonNullable<unknown> }} Rental_DurationInputs */

const en_rental_duration = /** @type {(inputs: Rental_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} nights`)
};

const es_rental_duration = /** @type {(inputs: Rental_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} noches`)
};

const fr_rental_duration = /** @type {(inputs: Rental_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} nuits`)
};

const de_rental_duration = /** @type {(inputs: Rental_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} Nächte`)
};

const id_rental_duration = /** @type {(inputs: Rental_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} malam`)
};

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const ja_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const zh_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const ar_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const it_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const ru_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const pt_rental_duration = en_rental_duration;

/** @type {(inputs: Rental_DurationInputs) => LocalizedString} */
const ko_rental_duration = en_rental_duration;

/**
* | output |
* | --- |
* | "{nights} nights" |
*
* @param {Rental_DurationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_duration = /** @type {((inputs: Rental_DurationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_DurationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_duration(inputs)
	if (locale === "es") return es_rental_duration(inputs)
	if (locale === "fr") return fr_rental_duration(inputs)
	if (locale === "de") return de_rental_duration(inputs)
	if (locale === "ja") return ja_rental_duration(inputs)
	if (locale === "zh") return zh_rental_duration(inputs)
	if (locale === "ar") return ar_rental_duration(inputs)
	if (locale === "id") return id_rental_duration(inputs)
	if (locale === "it") return it_rental_duration(inputs)
	if (locale === "ru") return ru_rental_duration(inputs)
	if (locale === "pt") return pt_rental_duration(inputs)
	return ko_rental_duration(inputs)
});